const serializeCommand = (value) => {
	if (Array.isArray(value)) return value.map(serializeCommand);
	if (value && typeof value === 'object') {
		return Object.keys(value).sort().reduce((result, key) => {
			if (value[key] !== undefined) result[key] = serializeCommand(value[key]);
			return result;
		}, {});
	}
	return value;
};

const createKey = () =>
	(typeof window !== 'undefined' && window.crypto?.randomUUID?.()) ||
	`acao-${Date.now()}-${Math.random().toString(36).slice(2)}`;

// A chave pertence à decisão, não ao regime ou ao mês. Uma resposta perdida
// mantém também o comando assinado, para repetir exatamente a mesma aplicação.
export const createEscalaMutationIntent = ({ generateKey = createKey } = {}) => {
	let pending = null;
	let submitting = false;
	let identity;
	let identityVersion = 0;
	return {
		setIdentity(value) {
			if (identity !== value) {
				identity = value;
				identityVersion += 1;
				pending = null;
			}
		},
		captureIdentity() {
			return identityVersion;
		},
		isCurrentIdentity(version) {
			return identityVersion === version;
		},
		tryStart() {
			if (submitting) return false;
			submitting = true;
			return true;
		},
		release() {
			submitting = false;
		},
		getDecision(command) {
			const signature = JSON.stringify(serializeCommand(command));
			if (!pending || pending.signature !== signature) {
				pending = { signature, key: generateKey(), request: null };
			}
			return pending;
		},
		complete(decision) {
			if (pending === decision) pending = null;
		},
	};
};
